import { render, staticRenderFns } from "./editsound.vue?vue&type=template&id=a0c7dd14&scoped=true&"
import script from "./editsound.vue?vue&type=script&lang=js&"
export * from "./editsound.vue?vue&type=script&lang=js&"
import style0 from "./editsound.vue?vue&type=style&index=0&id=a0c7dd14&prod&scoped=true&lang=css&"
import style1 from "./editsound.vue?vue&type=style&index=1&id=a0c7dd14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c7dd14",
  null
  
)

export default component.exports